import React from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';
import BuildInfo from '../BuildInfo';

const Header = ({ auth }) => {
  return (
    <AppBar 
      position="fixed" 
      sx={{ 
        zIndex: 1100,
        backgroundColor: 'white',
        color: '#1a1a1a',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        width: 'calc(100% - 200px)', // Subtract sidebar width
        ml: '200px', // Match sidebar width
        borderBottom: '1px solid rgba(0,0,0,0.06)'
      }}
    >
      <Toolbar sx={{ 
        display: 'flex', 
        justifyContent: 'space-between',
        alignItems: 'center',
        minHeight: '64px',
      }}>
        {/* Left side - could add additional items here */}
        <Box />
        
        {/* Center - App name */}
        <Typography 
          variant="h6" 
          component="div"
          sx={{
            fontWeight: 500,
            fontSize: '1.125rem',
            letterSpacing: '0.02em',
            background: 'linear-gradient(45deg, #2196F3, #1976D2)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            color: 'transparent',
            padding: '0.5rem 0',
          }}
        >
          {auth?.currentApp?.name || 'Dashboard'}
        </Typography>
        
        {/* Right side - Build info */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <BuildInfo variant="chip" />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header; 